/**
 * Global brand theme — Sothema (sothema branch).
 * Use these tokens everywhere. Do not hardcode brand colors in components.
 */

export const brand = {
  id: "sothema",
  name: "Sothema",
  logoUrl: "/sothema-logo-horizontal.svg",
  logoWhiteUrl: "/sothema-logo-horizontal-white.svg",
  /** Compact mark — mini drawer + favicon */
  iconUrl: "/icon.svg",

  colors: {
    accent: "#0074C8",
    accentHover: "#005A9E",
    accentSoft: "rgba(0, 116, 200, 0.12)",
    accentRing: "rgba(0, 116, 200, 0.22)",
    accentBorder: "rgba(0, 116, 200, 0.4)",
    ink: "#292929",
    muted: "#5C5C5C",
    line: "rgba(41, 41, 41, 0.14)",
    surface: "#FFFFFF",
    surfaceSoft: "rgba(255, 255, 255, 0.92)",
    bg: "#F7F9FB",
    bgElevated: "#FFFFFF",
    critical: "#F53340",
    criticalSoft: "rgba(245, 51, 64, 0.12)",
    onAccent: "#FFFFFF",
    secondary: "#6BC4EA",
  },

  fonts: {
    display: 'Raleway, "Helvetica Neue", Helvetica, Arial, sans-serif',
    body: 'Raleway, "Helvetica Neue", Helvetica, Arial, sans-serif',
  },

  radius: {
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    pill: "999px",
  },

  iconFilters: {
    muted:
      "brightness(0) saturate(100%) invert(35%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
    accent:
      "brightness(0) saturate(100%) invert(36%) sepia(98%) saturate(1200%) hue-rotate(182deg) brightness(95%) contrast(101%)",
    ink: "brightness(0) saturate(100%) invert(12%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
    onAccent: "brightness(0) saturate(100%) invert(100%)",
  },
};

export default brand;
